import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import cookie from "react-cookies";

import { moment, renderNumberGreaterThan100 } from "../common/common";

import InsuranceDetail from "./components/insurancedetail";
import { InsuranceWDDetail } from "./components/insurancedetail";

import { getLoggedProfile } from "../../actions/sessionAct";
import { bookCar, getPhoneInsurance } from "../../model/car";
import { getProfile } from "../../model/profile";

import { commonErr } from "../common/errors";
import { LoadingPage } from "../common/loading";
import { formatPrice, trackOrderToAccessTrade, trackOrderToOptimise, stypes, CarTransmission } from "../common/common";
import { initMap, parseAddressToLocationWithLatLng } from "../common/wdfunction";

import Login from "../login/login";
import SignUp from "../login/signup";

import {
	IcStarRating,
	IcLocationBlack,
	IcTotalTrip,
	IcStartLocGreen,
	IcEndLocGreen,
	IcCalendarBlack,
	Success,
	Fail,
	IcProtect,
	IcMapRoute,
	IcChevronRight
} from "../common/svg";
import { Papers, Mortgates, Policy, Surcharge } from "../car/components/infocar";

import Insurance from "./components/insurance";
import PriceSummary from "./components/pricesummary";
import CancelPolicy from "./components/cancelpolicy";


import car_photo from "../../static/images/upload/car_1.png";
import avatar_default from "../../static/images/avatar_default.png";
import { mapSdk } from "../../model/base";

class MapBox extends React.Component {

	constructor(props) {
		super(props);
	}

	close = () => {
		this.props.onHide()
	}


	render() {
		const { location, show, isSD, address, wdOneWay, locAddress, selfPickup  } = this.props;

 		return <Modal
				show={show}
				onHide={this.close}
				
				dialogClassName="modal-l modal-dialog modal-input">
					<Modal.Header closeButton={true} closeLabel={""}>
						<h5 ref={this.mapLoc}>Địa điểm giao nhận xe</h5>
					</Modal.Header>
					<Modal.Body>
						{isSD ? <CarMapLocation selfPickup={selfPickup} location={location} /> : <TripMapRoutes address={address} wdOneWay={wdOneWay} locAddress={locAddress} /> } 
					</Modal.Body>
				</Modal>
	}
}

class CarMapLocation extends React.Component {

	constructor(props) {
		super(props);

		this.mapLoc = React.createRef();
	}
	componentDidMount() {
		
		if (this.props.location) {
			setTimeout(() => {
				this.initMap(this.props.location.lat, this.props.location.lon);
			}, 100);
		}
	}

	initMap = (lat, lng) => {
		const mapName = this.props.selfPickup ? "car-map" : "loc-map";
		if (mapSdk != 0) {
			setTimeout(() => {
				initMap(true, this.mapLoc, [{ lat: lat, lng: lng }], false, mapName);
			}, 1000);
			return;
		}
	}

	close = () => {
		this.props.onHide()
	}


	render() {
		const { stype } = this.props;
 		return  <div ref={this.mapLoc} id="mapLoc" className="wrap-map" style={{'height': '500px'}}  />
				
	}
}



class TripMapRoutes extends React.Component {
	constructor(props) {
		super(props);

		this.map = React.createRef();
	}

	componentDidMount() {
		setTimeout(() => {
			this.initMap(this.props.wdOneWay, this.refs, this.props.locAddress, this.props.directionsResponse);
		}, 0);
	}

	initMap(wdOneWay, refs, locAddress, directionsResponse) {
		if (mapSdk != 0) {
			initMap(wdOneWay, this.map, locAddress, false, "map-deli", stypes.WD);
			return;
		}
	}

	render() {
		return (
			<div className="map-route">
				<div
					ref={this.map}
					id="loc-map"
					style={{ width: "100%", height: "500px", borderRadius: "16px", background: "#E0E0E0" }}
				/>
			</div>
		);
	}
}

class HistoryMessages extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedIndex: 0,
		};
	}

	onUpdate = () => {
		this.props.onUpdate(cookie.load("_mmessages")[this.state.selectedIndex]);
		this.props.onHide();
	};

	onHide = () => {
		this.props.onHide();
	};

	onSelectMessage = (i) => {
		this.setState({
			selectedIndex: i,
		});
	};

	render() {
		const { selectedIndex } = this.state;

		return (
			<Modal show={this.props.show} onHide={this.onHide} dialogClassName="modal-s modal-text">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Gợi ý lời nhắn</h5>
				</Modal.Header>
				<Modal.Body>
					<div className="modal-text-body modal-message-history">
						{cookie.load("_mmessages") ? (
							cookie.load("_mmessages").map((message, i) => (
								<div className="custom-radio">
									<input
										type="radio"
										id={`msg_${i}`}
										name="radio"
										onChange={() => this.onSelectMessage(i)}
										checked={selectedIndex === i}
									/>
									<label htmlFor={`msg_${i}`}>{message}</label>
								</div>
							))
						) : (
							<div className="custom-radio">
								<p className="note font-12">Chưa có gợi ý lời nhắn</p>
							</div>
						)}
						<div className="wrap-btn has-2-btn">
							<a className="btn btn--m btn-primary" disabled={!cookie.load("_mmessages")} onClick={this.onUpdate}>
								Thay thế
							</a>
							<a className="btn btn-link" onClick={this.onHide}>
								Hủy
							</a>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		);
	}
}

const ConfirmWD = ({ show, onHide, onBook, car }) => {
	return (
		<Modal show={show} onHide={() => onHide()} dialogClassName="modal-s modal-register modal-document">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Lưu ý</h5>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-register-body modal-document-body">
					<div className="block-content textAlign-center">
						<p>
							Phí đã bao gồm tiền tài xế, xăng xe, phí qua đêm, phục vụ chở khách tại điểm đến. Chưa bao gồm phí cầu
							đường, bến bãi...
						</p>
					</div>

					<div className="wrap-btn has-2-btn">
						<a className="btn btn--m btn-primary" onClick={() => onBook()}>
							Gủi yêu cầu thuê xe
						</a>
						<a className="btn btn-link" onClick={() => onHide()}>
							Hủy thuê
						</a>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

const ConfirmPapers = ({ show, onHide, onBook, car }) => {
	return (
		<Modal show={show} onHide={() => onHide()} dialogClassName="modal-s modal-text">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Lưu ý</h5>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-text-body modal-document-body">
					{car.optionsTransmission === 2 ? (
						<div className="block-content textAlign-center">
							{/* <p className="body-title">Truyền động</p> */}
							<p>[+] Xe {CarTransmission[car.optionsTransmission]}</p>
							<p>Bạn cần có GPLX (B2 trở lên) và kỹ năng phù hợp.</p>
						</div>
					) : null}

					{car.insSupport === 1 ? (
						<div className="block-content textAlign-center">
							<p>[+] Bảo hiểm thuê xe</p>
							<p>
								Chuyến đi của bạn được mua bảo hiểm thuê xe. Trường hợp xảy ra sự cố ngoài ý muốn, bạn chỉ phải bồi
								thường tối đa 2,000,000 VNĐ cho các thiệt hại về xe
							</p>
							{/* <p>
								Xe đã đăng ký “Bảo hiểm chuyến đi”, mức khấu trừ 2 triệu đồng (mọi thiệt hại ngoài ý muốn về xe và trong
								phạm vi bảo hiểm, khách thuê bồi thường tối đa 2 triệu đồng)
							</p>
							<table>
								<tbody>
									<tr>
										<td>
											<p>Thiệt hại xe </p>
										</td>
										<td>
											<p>Khách thanh toán </p>
										</td>
										<td>
											<p>Bảo hiểm thanh toán</p>
										</td>
									</tr>
									<tr>
										<td>
											<p>&lt;= 2 triệu</p>
										</td>
										<td>
											<p>&lt;= 2 triệu </p>
										</td>
										<td>
											<p>0 đồng </p>
										</td>
									</tr>
									<tr>
										<td>
											<p>&gt;2 triệu</p>
										</td>
										<td>
											<p>2 triệu </p>
										</td>
										<td>
											<p>Giá trị còn lại </p>
										</td>
									</tr>
								</tbody>
							</table>
							<p className="font-14 note">
							(*) Thiệt hại xe được ước tính theo báo giá của các garage trong mạng lưới đối tác bảo hiểm hiện hành của
							Mioto.{" "}</p> */}
						</div>
					) : (
						<div className="block-content textAlign-center">
							<p>[+] Bảo hiểm thuê xe</p>
							<p>
								Chuyến đi của bạn không được mua bảo hiểm thuê xe. Bạn sẽ thỏa thuận trực tiếp với chủ xe trường hợp có
								xảy ra sự cố ngoài ý muốn gây thiệt hại về xe.
							</p>
						</div>
					)}

					<div className="wrap-btn has-2-btn">
						<a className="btn btn--m btn-primary" onClick={() => onBook()}>
							Gửi yêu cầu thuê xe
						</a>
						<a className="btn btn-link" onClick={() => onHide()}>
							Hủy thuê
						</a>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

class BookingResult extends React.Component {
	render() {
		const { err, errMsg, car, trip, close, togglePopup, closePopup } = this.props;
		if (err >= commonErr.SUCCESS) {
			if (car.instant) {
				return (
					<div className="modal-confirm-body modal-done-booking-body">
						<p>
							Yêu cầu thuê xe đã được duyệt tự động. <br />
							Bạn vui lòng đặt cọc ngay để hoàn tất việc đặt xe
						</p>
						<div className="wrap-btn db-btn">
							{closePopup ? (
								<a
									onClick={() => {
										close();
										togglePopup(trip.carId);
									}}
									className="btn btn--m btn-default">
									Đặt thêm xe khác
								</a>
							) : (
								<a onClick={close} className="btn btn--m btn-default">
									Đặt thêm xe khác
								</a>
							)}
							<Link
								to={`/payment/${trip.id}?deposit=${trip.priceSummary.deposit}&timeExpired=${trip.timeExpired}`}
								className="btn btn--m btn-primary">
								Đặt cọc nhanh
							</Link>
						</div>
					</div>
				);
			} else {
				return (
					<div className="modal-confirm-body renter-confirm-body">
						<p className="font-14">
							Yêu cầu thuê xe của bạn đã được gửi đến chủ&nbsp;xe.
							<br />
							Bạn vui lòng chờ chủ xe xác nhận, sau đó tiến hành đặt cọc ngay để hoàn tất&nbsp;việc đặt&nbsp;xe
						</p>
						<p className="font-12 text-primary">
							Lưu ý: Trong thời gian chờ xác nhận, bạn có thể gửi thêm yêu cầu thuê xe đến nhiều chủ xe khác, và ưu tiên
							lựa chọn chủ xe xác nhận sớm để đặt cọc (hệ&nbsp;thống sẽ tự động hủy các yêu&nbsp;cầu thuê&nbsp;xe
							còn&nbsp;lại)
						</p>
						<div className="wrap-btn has-2-btn">
							<Link to={`/trip/detail/${trip.id}`} className="btn btn--m btn-primary">
								Quản lý chuyến
							</Link>
							{closePopup ? (
								<a
									onClick={() => {
										close();
										togglePopup(trip.carId);
									}}
									className="btn btn--m btn-default">
									Đặt thêm xe khác
								</a>
							) : (
								<a onClick={close} className="btn btn--m btn-default">
									Đặt thêm xe khác
								</a>
							)}
						</div>
					</div>
				);
			}
		} else {
			return (
				<div className="modal-confirm-body">
					<p>
						Đặt xe thất bại.
						<br />
						{errMsg}
					</p>
				</div>
			);
		}
	}
}

class BookingConfirm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			isShowMoreText: false,
			showLoginForm: false,
			priceSummary: null,
			messageToOwner: "",
			showHistoryMessages: false,
			showConfirmPapers: false,
			showConfirmWD: false,
			readPolicy: true,
			// if change placeholderMsg, change messageToOwner
			placeholderMsg:
				this.props.stype === stypes.SD
					? `Gợi ý: \n\nChào anh chủ xe! \n\nTôi cần thuê xe của anh để đi du lịch cùng gia đình với thời gian như trên. \nTôi có đầy đủ giấy tờ thuê xe và tài sản thế chấp như yêu cầu. \n\nAnh vui lòng báo giúp tình trạng xe sớm nhé. Cảm ơn anh!`
					: `Gợi ý: Chào anh A chủ xe.\nTôi cần đặt xe đi du lịch Vũng Tàu/Đồ Sơn cùng gia đình với thời gian như trên.\nAnh vui lòng sắp xếp báo giúp tình trạng xe sớm nhé.\nCảm ơn anh!`,
			showDetailIns: false,
			showMapBox: false 
		};
		this.stype = this.props.stype;
		this.isSD = this.props.stype === stypes.SD;

		this.heightRules = React.createRef();

	}

	componentDidMount() {
		if (this.props.uid) {
			getProfile(this.props.uid, "pd" /*view count for server*/).then((resp) => {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					data: resp.data.data,
				});
			});
		}
		this.getPhoneInsurance();

		this.setState({
			activeIns: this.props.car.insSupport === 1 ? this.props.car.insBy[0] : 0, //??????
		});

		if (this.isSD) {
			this.setState({
				messageToOwner: `Gợi ý: \n\nChào anh chủ xe! \n\nTôi cần thuê xe của anh để đi du lịch cùng gia đình với thời gian như trên. \nTôi có đầy đủ giấy tờ thuê xe và tài sản thế chấp như yêu cầu. \n\nAnh vui lòng báo giúp tình trạng xe sớm nhé. Cảm ơn anh!`,
			});
		} else {
			this.setState({
				messageToOwner: `Gợi ý: Chào anh A chủ xe.\nTôi cần đặt xe đi du lịch Vũng Tàu/Đồ Sơn cùng gia đình với thời gian như trên.\nAnh vui lòng sắp xếp báo giúp tình trạng xe sớm nhé.\nCảm ơn anh!`,
			});
		}
	}

	getPhoneInsurance = () => {
		getPhoneInsurance().then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
				this.setState({
					phoneInsMic: resp.data.data.zones,
					phoneInsPjico: resp.data.data.zonesPjico,
					phoneInsPVI: resp.data.data.zonesPVI,
					phoneInsVNI: resp.data.data.zonesVNI,
				});
			}
		});
	};

	onReadMore = () => {
		this.setState({
			isShowMoreText: true,
		});
	};

	openDetailIns = () => {
		this.setState({
			showDetailIns: true,
		});
	};

	closeDetailIns = () => {
		this.setState({
			showDetailIns: false,
		});
	};

	// onInsChange = (e) => {
	// 	let activeIns = parseInt(e.target.value);
	// 	this.setState({
	// 		activeIns
	// 	})
	// }

	openLoginForm = () => {
		this.setState({
			showLoginForm: true,
		});
	};

	closeLoginForm = () => {
		this.setState({
			showLoginForm: false,
		});
	};

	closeMessageBox = () => {
		this.setState({
			errMsg: "",
		});
	};

	closeHistoryMessages = () => {
		this.setState({
			showHistoryMessages: false,
		});
	};

	openHistoryMessages = () => {
		this.setState({
			showHistoryMessages: true,
		});
	};

	onSetMessage = (message) => {
		this.setState({
			messageToOwner: message,
		});
	};

	getLoggedProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};

	onMessageToOwnerChange = (e) => {
		this.setState({
			messageToOwner: e.target.value,
		});
	};
	onMessageFocus = () => {
		const { messageToOwner, placeholderMsg } = this.state;
		if (messageToOwner === placeholderMsg) {
			this.setState({
				messageToOwner: "",
			});
		}
	};

	onMessageBlur = () => {
		const { messageToOwner, placeholderMsg } = this.state;

		if (messageToOwner === "") {
			this.setState({
				messageToOwner: placeholderMsg,
			});
		}
	};

	// readPaperChange = (event) => {
	// 	this.setState({
	// 		readPaper: event.target.checked
	// 	});
	// }

	readPolicyChange = (event) => {
		this.setState({
			readPolicy: event.target.checked,
		});
	};

	readConfirmPapers = () => {
		this.setState({
			showConfirmPapers: true,
		});
	};

	closeConfirmPapers = () => {
		this.setState({
			showConfirmPapers: false,
		});
	};

	readConfirmWD = () => {
		this.setState({
			showConfirmWD: true,
		});
	};

	closeConfirmWD = () => {
		this.setState({
			showConfirmWD: false,
		});
	};

	openMapBox = () => {
		this.setState({
			showMapBox: true 
		})
	}

	closeMapBox = () => {
		this.setState({
			showMapBox: false 
		})
	}

	isValidBooking = () => {
		if (this.isSD) {
			const car = this.props.car;
			if (
				(car.requiredPapers && car.requiredPapers.length === 0) ||
				(car.requiredPapersOther && car.requiredPapersOther === "")
			) {
				return false;
			}
		}

		if (!this.state.readPolicy) {
			return false;
		}

		return true;
	};

	booking = () => {
		if (!this.props.session.profile || !this.props.session.profile.info || !this.props.session.profile.info.uid) {
			this.openLoginForm();
		} else {
			this.setState({
				err: commonErr.LOADING,
			});

			

			const { car, promoCode, deliveryId } = this.props;
			const { placeholderMsg } = this.state;
			let pprice; 

			if (this.isSD) {
				pprice = car.priceSummary 
				pprice.specialDiscountDesc = "";
			}

			const startDate = this.props.startDate.valueOf();
			const endDate = this.props.endDate.valueOf();
			const dAddr = this.props.fromAddress;
			let message = this.state.messageToOwner;
			const profile = this.state.data.profile;
			const totalTrip = profile.traveler.totalTrips + profile.owner.totalTrips;

			var dLat = this.isSD ? car.location.lat : this.props.fromAddressLoc.lat;
			var dLon = this.isSD ? car.location.lon : this.props.fromAddressLoc.lon;
			const insuranceBy = this.props.insuranceBy;
			const instant = this.isSD ? (car.instant === 1 ? true : false) : car.wdShort.instant === 1 ? true : false;
			const useCarLocation = this.isSD ? this.props.selfPickup : this.props.isDeliveryByAddressCar;
			const limitEnable = this.isSD ? (car.limitEnable === 1 ? true : false) : undefined;
			const limitKM = this.isSD ? car.limitKM : undefined;
			const limitPrice = this.isSD ? car.limitPrice : undefined;
			const price = this.isSD ? JSON.stringify(pprice) : undefined;
			const wdDistance = this.isSD ? undefined : this.props.wdDistance;
			const wdDistanceBackOW = this.isSD ? undefined : this.props.wdDistanceBackOW;
			const wdOneWay = this.isSD ? undefined : this.props.wdOneWay;
			const wdLocations = this.isSD ? undefined : this.props.wdLocations;
			const wdPrice = this.isSD ? undefined : JSON.stringify(car.wdFull.priceSummary);

			if (message == placeholderMsg) {
				message = "";
			}

			// save message to cookie
			if (message !== "" && message != placeholderMsg) {
				let cMessages = cookie.load("_mmessages") ? cookie.load("_mmessages") : [];
				let duplicated = false;
				for (let cMessage of cMessages) {
					if (message === cMessage) {
						duplicated = true;
						break;
					}
				}
				if (!duplicated) {
					cMessages.push(message);
					if (cMessages.length === 6) {
						cMessages.shift();
					}
					cookie.save("_mmessages", cMessages, { path: "/", expires: moment().add(1, "months").toDate() });
				}
			}

	

			if (useCarLocation) {
				bookCar(
					car.id,
					instant,
					startDate,
					endDate,
					price,
					limitEnable,
					limitKM,
					limitPrice,
					useCarLocation,
					dLat,
					dLon,
					dAddr,
					message,
					promoCode,
					deliveryId,
					this.stype,
					wdDistance,
					wdDistanceBackOW,
					wdOneWay,
					wdLocations,
					wdPrice,
					insuranceBy
				).then((resp) => {
					if (resp.data.error >= commonErr.SUCCESS) {
						// track to Access trade
						const tripId = resp.data.data.trip.id;
						const totalPrice = this.isSD
							? resp.data.data.trip.priceSummary.priceTotal
							: resp.data.data.trip.wd.priceSummary.finalPrice;
						trackOrderToAccessTrade(tripId, totalPrice);

						// track to Optimise
						if (totalTrip == 0) {
							trackOrderToOptimise(tripId, totalPrice);
							if (this.isSD) {
								const utmSrc = cookie.load("_utm_src") || "web_directly";
								const utmExt = cookie.load("_utm_ext") || "no_label";
								const action = "FIRST_BOOKING";
								window.gtag("event", action, {
									event_category: utmSrc,
									event_label: utmExt,
									campaign: { source: utmSrc },
								});
								window.fbq("track", action);
								// window.ga('send', 'event', utmSrc, action, utmExt);
							} else {
								const utmSrc = cookie.load("_utm_src") || "web_directly";
								const utmExt = cookie.load("_utm_ext") || "no_label";
								const action = "FIRST_BOOKING_WITHDRIVER";
								window.gtag("event", action, {
									event_category: utmSrc,
									event_label: utmExt,
									campaign: { source: utmSrc },
								});
								window.fbq("track", action);
								// window.ga('send', 'event', utmSrc, action, utmExt);
							}
						}

						this.props.goToResult(resp.data.data.trip);
					} else {
						this.props.goToError(resp.data.error, resp.data.errorMessage);
					}
				});
			} else {
				parseAddressToLocationWithLatLng(
					dAddr,
					this.props.fromAddressLoc.lat,
					this.props.fromAddressLoc.lon,
					(location) => {
						dLat = location.lat;
						dLon = location.lng;

						bookCar(
							car.id,
							instant,
							startDate,
							endDate,
							price,
							limitEnable,
							limitKM,
							limitPrice,
							useCarLocation,
							dLat,
							dLon,
							dAddr,
							message,
							promoCode,
							deliveryId,
							this.stype,
							wdDistance,
							wdDistanceBackOW,
							wdOneWay,
							wdLocations,
							wdPrice,
							insuranceBy
						).then((resp) => {
							if (resp.data.error >= commonErr.SUCCESS) {
								// track to Access trade
								const tripId = resp.data.data.trip.id;
								const totalPrice = this.isSD
									? resp.data.data.trip.priceSummary.priceTotal
									: resp.data.data.trip.wd.priceSummary.finalPrice;
								trackOrderToAccessTrade(tripId, totalPrice);

								// track to Optimise
								if (totalTrip == 0) {
									trackOrderToOptimise(tripId, totalPrice);

									if (this.isSD) {
										const utmSrc = cookie.load("_utm_src") || "web_directly";
										const utmExt = cookie.load("_utm_ext") || "no_label";
										const action = "FIRST_BOOKING";
										// window.ga('send', 'event', utmSrc, action, utmExt);
										window.gtag("event", action, {
											event_category: utmSrc,
											event_label: utmExt,
											campaign: { source: utmSrc },
										});
										window.fbq("track", action);
									} else {
										const utmSrc = cookie.load("_utm_src") || "web_directly";
										const utmExt = cookie.load("_utm_ext") || "no_label";
										const action = "FIRST_BOOKING_WITHDRIVER";
										// window.ga('send', 'event', utmSrc, action, utmExt);
										window.gtag("event", action, {
											event_category: utmSrc,
											event_label: utmExt,
											campaign: { source: utmSrc },
										});
										window.fbq("track", action);
									}
								}

								this.props.goToResult(resp.data.data.trip);
							} else {
								this.props.goToError(resp.data.error, resp.data.errorMessage);
							}
						});
					}
				);
			}

			//GA
			const utmSrc = cookie.load("_utm_src") || "web_directly";
			const utmExt = cookie.load("_utm_ext") || "no_label";
			const action = this.isSD
				? car.instant
					? "CAR_BOOKING_INSTANTLY"
					: "CAR_BOOKING"
				: car.wdShort.instant === 1
				? "CAR_BOOKING_INSTANTLY_WITHDRIVER"
				: "CAR_BOOKING_WITHDRIVER";
			window.gtag("event", action, {
				event_category: utmSrc,
				event_label: utmExt,
				campaign: { source: utmSrc },
			});
			window.fbq("track", action);
		}
	};

	render() {
		//height line = 168px ~ 8 lines
		const heightRules = this.heightRules.current ? this.heightRules.current.clientHeight : 0;
		const heightMaximum = heightRules < 168;

		const {
			isShowMoreText,
			showConfirmPapers,
			showConfirmWD,
			messageToOwner,
			placeholderMsg,
			activeIns,
			phoneInsMic,
			phoneInsPjico,
			phoneInsPVI,
			phoneInsVNI,
			showMapBox
		} = this.state;
		const {
			car,
			owner,
			selfPickup,
			fromAddress,
			fromAddressLoc,
			startDate,
			endDate,
			promoCode,
			insuranceBy,
			backToSetup,
			address,
			wdOneWay,
			stype,
			calendar,
		} = this.props;
		const priceSummary = this.isSD ? car.priceSummary : car.wdFull ? car.wdFull.priceSummary : {};
		const specialDayStart = calendar.specialDays.filter((item) => moment(item.day).isSame(moment(startDate), "day"));
		const specialDayEnd = calendar.specialDays.filter((item) => moment(item.day).isSame(moment(endDate), "day"));
		const specialDayStartText = specialDayStart.length > 0 ? specialDayStart[0].name : undefined;
		const specialDayEndText = specialDayEnd.length > 0 ? specialDayEnd[0].name : undefined;


		let phonesIns =
			activeIns === 1 ? phoneInsMic : activeIns === 4 ? phoneInsVNI : activeIns === 3 ? phoneInsPVI : phoneInsPjico;

		if (this.state.err === commonErr.LOADING) {
			return <LoadingPage />;
		} else {
			return (
				<div className="confirm-booking">
					<div className="car-info">
						<div className="car-img">
							<img loading="lazy" src={car.photos ? car.photos[0].thumbUrl : car_photo} alt="Mioto - Thuê xe tự lái" />
						</div>
						<div className="info-inner">
							<div className="car-desc">
								<h5 className="name">{car.name}</h5>
								{car.totalTrips > 0 ? (
									<div className="desc-info">
										<div className="wrap-svg">
											<IcStarRating />
										</div>
										<span className="info">{car.rating.avg.toFixed(1)}</span>
										<span className="dot">•</span>
										<div className="wrap-svg">
											<IcTotalTrip />
										</div>
										<span className="info">{renderNumberGreaterThan100(car.totalTrips)} chuyến</span>
									</div>
								) : (
									<div className="desc-info">
										<span className="info">Chưa có chuyến</span>
									</div>
								)}
								<div className="address">
									<div className="wrap-svg">
										<IcLocationBlack />
									</div>
									<p>{car.locationAddr}</p>
								</div>
							</div>
							<Insurance
								activeIns={insuranceBy}
								insSupport={car.insSupport}
								openDetailIns={this.openDetailIns}
								disabled={true}
							/>
						</div>
					</div>

					<div className="desc-car">
						<h6>Thời gian thuê xe</h6>
						<div className="rental-time">
							<div className="rental-time__item">
								<div className="wrap-svg">
									<IcCalendarBlack />
								</div>
								<div className="title">
									<p className="sub">Bắt đầu thuê xe</p>
									<h6 className="main">{startDate.format("HH:mm - DD/MM/YYYY")}</h6>
									{specialDayStartText && <p className="label">{specialDayStartText}</p>}
								</div>
							</div>
							<div className="rental-time__item">
								<div className="wrap-svg">
									<IcCalendarBlack />
								</div>
								<div className="title">
									<p className="sub">Kết thúc thuê xe</p>
									<h6 className="main">{endDate.format("HH:mm - DD/MM/YYYY")}</h6>
									{specialDayEndText && <p className="label">{specialDayEndText}</p>}
								</div>
							</div>
						</div>
					</div>

					{this.isSD && (
						<>
							<div className="delivery-car">
								<div className="delivery-car__item">
									<h6 className="title">Địa chỉ giao nhận xe </h6>
									{selfPickup ? 
									<>
										<p>{car.locationAddr} </p> 
										<p className="note font-14">Địa chỉ cụ thể sẽ được hiển thị sau khi đặt cọc.</p>
									</>
									: 
									<p>{fromAddress}</p>}
									
									<div className="maps-detail" style={{cursor: 'pointer'}} onClick={this.openMapBox}> 
										<div className="wrap-svg"> 
											<IcMapRoute />
										</div>
										<p className="font-14 fontWeight-7">Xem bản đồ</p>
										<div className="wrap-svg"> 
											<IcChevronRight />
										</div>
									</div>
								</div>
							</div>
							{/* <CarMapLocation show={showMapBox} onHide={this.closeMapBox} location={selfPickup ? car.location : fromAddressLoc} /> */}
						
							 <MapBox show={showMapBox} onHide={this.closeMapBox} selfPickup={selfPickup} location={selfPickup ? car.location : fromAddressLoc} isSD={this.isSD} />
						
						</>
					)}

					{!this.isSD && (
						<>
							<div className="delivery-car-wd">
								<h6 className="route">
									Lộ trình:{" "}
									{address.length === 1 ? "Nội thành" : wdOneWay ? "Liên tỉnh - 1 chiều" : "Liên tỉnh - 2 chiều"}
								</h6>

								<div className="address-route">
									<div className="wrap-svg">
										<IcStartLocGreen />
									</div>
									{address[0]}
								</div>

								{address.map((address, index) => {
									if (index === 0) return null;
									return (
										<div className="address-route">
											<div className="wrap-svg">
												<IcEndLocGreen />
											</div>
											{address}
										</div>
									);
								})}

								<div className="maps-detail" onClick={this.openMapBox} style={{cursor: 'pointer'}}> 
									<div className="wrap-svg"> 
										<IcMapRoute />
									</div>
									<p className="font-14 fontWeight-7">Xem bản đồ</p>
									<div className="wrap-svg"> 
										<IcChevronRight />
									</div>
								</div>
							</div>

						

							<MapBox show={showMapBox} onHide={this.closeMapBox} address={address} wdOneWay={this.props.wdOneWay} locAddress={this.props.locAddress} isSD={this.isSD} />
						</>
					)}

					<div className="profile">
						<div
							className={`avatar avatar--m ${
								(this.isSD && owner.owner.ownerHostFiveStarSD > 0) ||
								(!this.isSD && owner.owner.ownerHostFiveStarWD > 0)
									? "has-five-star"
									: ""
							}`}>
							<img
								loading="lazy"
								src={owner && owner.avatar && owner.avatar.fullUrl ? owner.avatar.fullUrl : avatar_default}
								alt=""
							/>
						</div>
						<div className="profile-desc">
							<p>Chủ xe</p>
							<h6 className="name">{owner.name}</h6>
							{owner.owner.totalTrips > 0 ? (
								<div className="desc-info">
									<div className="wrap-svg">
										<IcStarRating />
									</div>
									<span className="info">{owner.owner.rating.avg.toFixed(1)}</span>
									<span className="dot">•</span>
									<div className="wrap-svg">
										<IcTotalTrip />
									</div>
									<span className="info">{renderNumberGreaterThan100(owner.owner.totalTrips)} chuyến</span>
								</div>
							) : (
								<div className="desc-info">
									<span className="info">Chưa có đánh giá</span>
								</div>
							)}
						</div>
						<p className="profile-note">
							Nhằm bảo mật thông tin cá nhân, Mioto sẽ gửi chi tiết liên hệ của chủ xe sau khi khách hàng hoàn tất bước
							thanh toán trên ứng&nbsp;dụng.
						</p>
					</div>
					<div className="message">
						<div className="message-wrapper">
							<p className="title">Lời nhắn đến chủ xe</p>
							{cookie.load("_mmessages") && (
								<p className="history" onClick={this.openHistoryMessages}>
									Gợi ý lời nhắn
								</p>
							)}
						</div>
						<div className="custom-textarea">
							<textarea
								className={`textarea ${messageToOwner === placeholderMsg ? "text-gray" : ""}`}
								onChange={this.onMessageToOwnerChange}
								onFocus={this.onMessageFocus}
								onBlur={this.onMessageBlur}
								rows="25"
								value={messageToOwner}></textarea>
						</div>
						<div className="message-note">
							<div className="wrap-svg">
								<IcProtect />
							</div>
							<p className="sub-text">
								Giao dịch qua Mioto để chúng tôi bảo vệ tốt nhất trong trường hợp bị hủy chuyến ngoài ý muốn & phát sinh
								sự cố bảo&nbsp;hiểm
							</p>
						</div>
					</div>

					{this.isSD && <Papers info={car} trip={true} />}

					{this.isSD && <Mortgates info={car} trip={true} />}


					<PriceSummary
						priceSummary={priceSummary}
						isSD={this.isSD}
						title={"Bảng tính giá"}
						promo={promoCode && promoCode.code ? promoCode.code : null}
					/>


					<div className="wrap-btn db-btn">
						<a className="btn btn--m btn-secondary" onClick={backToSetup}>
							Hủy
						</a>
						{this.isSD ? (
							<a
								className="btn btn--m btn-primary"
								onClick={this.readConfirmPapers}
								disabled={this.isValidBooking() === true ? false : true}>
								Gởi yêu cầu thuê xe
							</a>
						) : (
							<a
								className="btn btn--m btn-primary"
								onClick={this.readConfirmWD}
								disabled={this.isValidBooking() === true ? false : true}>
								Gởi yêu cầu thuê xe
							</a>
						)}
					</div>
					<p className="last-note">
						(*Trường hợp nhiều khách đặt xe cùng một thời điểm, hệ thống sẽ ưu tiên khách hàng thanh toán sớm nhất)
					</p>
					{this.state.showLoginForm && (
						<>
							<Login
								show={this.state.showLoginForm}
								openSignupForm={this.openSignupForm}
								showModal={this.openLoginForm}
								hideModal={this.closeLoginForm}
								getLoggedProfile={this.getLoggedProfile}
							/>
							<SignUp
								show={this.state.showSignup}
								showModal={this.openSignupForm}
								hideModal={this.closeSignupForm}
								openLoginForm={this.openLoginForm}
								getLoggedProfile={this.getLoggedProfile}
							/>
						</>
					)}
					{this.state.showHistoryMessages && (
						<HistoryMessages
							show={this.state.showHistoryMessages}
							onHide={this.closeHistoryMessages}
							onUpdate={this.onSetMessage}
						/>
					)}
					{showConfirmPapers && (
						<ConfirmPapers car={car} show={showConfirmPapers} onHide={this.closeConfirmPapers} onBook={this.booking} />
					)}
					{showConfirmWD && (
						<ConfirmWD car={car} show={showConfirmWD} onHide={this.closeConfirmWD} onBook={this.booking} />
					)}

				</div>
			);
		}
	}
}

class CarBooking extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			step: 1,
			trip: null,
		};
		this.stype = this.props.stype;
		this.isSD = this.props.stype === stypes.SD;
	}

	componentDidMount() {}

	goToResult = (trip) => {
		this.setState({
			step: 2,
			trip: trip,
		});
	};

	goToError = (err, errMsg) => {
		this.setState({
			step: 2,
			err: err,
			errMsg: errMsg,
		});
	};

	close = () => {
		this.setState({
			step: 1,
			err: commonErr.INNIT,
			trip: null,
		});
		this.props.hideModal();
	};

	render() {
		var content;
		var title;
		var modalClass;
		var checkImg;
		if (this.state.err === commonErr.LOADING) {
			content = (
				<section className="body">
					<LoadingPage />
				</section>
			);
		} else {
			const { err, errMsg, step, trip } = this.state;
			const {
				closePopup,
				togglePopup,
				uid,
				car,
				owner,
				selfPickup,
				fromAddress,
				fromAddressLoc,
				startDate,
				endDate,
				promoCode,
				address,
				wdDistance,
				wdDistanceBackOW,
				wdOneWay,
				wdLocations,
				isCityTourMode,
				isDeliveryByAddressCar,
				locAddress,
				directionsResponse,
				insuranceBy,
				deliveryId,
				stype,
				calendar,
			} = this.props;
			switch (step) {
				case 2:
					content = (
						<BookingResult
							closePopup={closePopup}
							togglePopup={togglePopup}
							err={err}
							errMsg={errMsg}
							car={car}
							close={this.close}
							trip={trip}
						/>
					);
					title = "";
					modalClass = "modal-s modal-confirm";
					checkImg = true;
					break;
				default:
					content = (
						<BookingConfirm
							uid={uid}
							car={car}
							promoCode={promoCode}
							insuranceBy={insuranceBy}
							owner={owner}
							selfPickup={selfPickup}
							fromAddress={fromAddress}
							fromAddressLoc={fromAddressLoc}
							startDate={startDate}
							endDate={endDate}
							backToSetup={this.close}
							goToResult={this.goToResult}
							goToError={this.goToError}
							deliveryId={deliveryId}
							address={address}
							locAddress={locAddress}
							directionsResponse={directionsResponse}
							stype={this.stype}
							wdDistance={wdDistance}
							wdDistanceBackOW={wdDistanceBackOW}
							wdOneWay={wdOneWay}
							wdLocations={wdLocations}
							isCityTourMode={isCityTourMode}
							isDeliveryByAddressCar={isDeliveryByAddressCar}
							calendar={calendar}
						/>
					);
					title = "Xác nhận đặt xe";
					modalClass = "modal-l modal-confirm-booking modal-fix";
					checkImg = false;
			}
		}

		return (
			<Modal show={this.props.show} onHide={this.close} dialogClassName={`${modalClass}`}>
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>{title}</h5>
					{checkImg && (this.state.err >= commonErr.SUCCESS ? <Success /> : <Fail />)}
				</Modal.Header>
				<Modal.Body>{content}</Modal.Body>
			</Modal>
		);
	}
}

function mapSessionState(state) {
	return {
		session: state.session,
	};
}
BookingConfirm = connect(mapSessionState)(BookingConfirm);

function mapDetailState(state) {
	return {
		carDetail: state.carDetail,
	};
}
CarBooking = connect(mapDetailState)(CarBooking);

export default CarBooking;
